<template>
  <section class="py-20 bg-white">
    <div class="container mx-auto px-4">
      <div class="flex flex-col md:flex-row items-center">
        <div class="md:w-1/2 md:pr-12 mb-10 md:mb-0">
          <div class="text-title font-bold text-[#333333] leading-tight mb-6">
            OUR MANUFACTURING STRENGTH
          </div>
          <div class="text-desc mb-6">
            Supported by our complete in-house capabilities and a meticulous
            process control system, we ensure exceptional quality—as verified
            by our advanced equipment and professional certifications
          </div>
          <!-- <ul class="space-y-4 mb-8> -->
          <ul class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mb-6">
            <li
              class="flex items-start"
              v-for="feature in features"
              :key="feature"
            >
              <i class="fa-regular fa-circle-check text-[#d4335d] mt-1 mr-3"></i>
              <span class="text-[15px] text-[#555555] font-semibold">{{ feature }}</span>
            </li>
          </ul>
        </div>
        <div class="md:w-1/2">
          <div class="relative">
            <img
              src="@/assets/web_pg_1.jpg"
              alt="WordPress Themes"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data () {
    return {
      features: [
        'Die casting machines',
        'Die-casting assisting robots',
        'Automatic coloring machines',
        'Polishing equipment',
        'CNC die engraving machines',
        'Milling machines',
        'Drilling press equipment',
        'Laser machines',
        'Tapping machines',
        'Industrial ovens'
      ]
    }
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/blogLayoutsSection.vue